export const getAjaxError = (response) => {
  let ajaxError = $.parseJSON(response.responseText).error.show;
  return ajaxError;
};


export const summaryLink = $('html').data('checkout-movie-summary-url');
export const indexLink = $('html').data('checkout-movie-index-url');
export const $checkoutDropdown = $('.checkout-preview-dropdown');
export const $checkoutIcon = $('.checkout__icon');
export const $addToCheckoutError = $('.product__info__form-error small');
export const $removeProductSuccess = $('.remove-product-alert');



export const onAddToCheckoutError = (response) => {
  $addToCheckoutError.html(getAjaxError(response));
};

export const onAddToCheckoutSuccess = () => {
  $('a#checkout-index').attr('href',indexLink);
  $('a.checkout__icon').attr('href',indexLink);   
  $.get(summaryLink, (data) => {
    $checkoutDropdown.html(data);
    $addToCheckoutError.html('');
    var newQunatity = $('.checkout-preview-dropdown__total').data('quantity');
    $('.badge').html(newQunatity).removeClass('empty');
    $checkoutDropdown.addClass('show');
    $checkoutIcon.addClass('hover');
    $checkoutDropdown.find('.checkout-preview-dropdown__list').scrollTop($checkoutDropdown.find('.checkout-preview-dropdown__list')[0].scrollHeight);
    setTimeout((e) => {
      $checkoutDropdown.removeClass('show');
      $checkoutIcon.removeClass('hover');
    }, 2500);
  });
};

$(document).ready(function () {

    function loadGrid() {
       if(!$('.inputBox').length){ 
	        console.log("returning for seat layout selector not found")
			return
		   }    		
        var seatData = $('.inputBox').val();
        var nuberOfSeat = $('.nuberOfSeat').val();
        seatData = JSON.parse(seatData.replaceAll("'", '"'));

        $('.selectMove').seatLayout({
            data: seatData,
            showActionButtons:false,
            classes : {
                doneBtn : '',
                cancelBtn : '',
                row:'',
                area:'',
                screen:'',
                seat:''
            },
            numberOfSeat: nuberOfSeat,
            callOnSeatRender: function (Obj) {
                //modify seat object if require and return it;
                return Obj;
            },
            callOnSeatSelect: function (_event, _data, _selected, _element) {
                console.log(_event);
                console.log(_data);
                console.log(_selected);
                console.log(_element);
				send(_data['selected'])
            },
            selectionDone: function (_array) {
                console.log(_array); 				
            },
            cancel: function () {
                return false;
            }
        });
    }
	function send(data, _selected){
	    console.log("raju:",data);	
	var local_data=data, local__selected=_selected;
      $.ajax({
        url: $('html').data('add-movie-url'),
        method: 'post',
        data: {
          data: JSON.stringify(data)
        },
        success: () => {
          console.log("raju success _selected", _selected);
          console.log("raju success data", data);	
          console.log("raju success local_data", local_data);
          console.log("raju success local__selected", local__selected);		  
		  onAddToCheckoutSuccess();
        },
        error: (response) => {
          console.log("raju error", $.parseJSON(response.responseText).error.show );
          console.log("raju error on this selected seat", _selected );	
          console.log("raju error on this selected seat data", data );	
          console.log("raju error on this selected seat local_data", local_data );	
          console.log("raju error on this selected seat local__selected", local__selected );			  
		  //$('.product__info__form-error big').html($.parseJSON(response.responseText).error.show)
          onAddToCheckoutError(response, );
		  document.getElementById("seat-layout").click();
        }
      });
		
	}
    loadGrid();
    $('.call-load-function').click(function(){
        loadGrid();
    });
    $("#exampleModal_inside").click(function(){
	   location.reload();
    });	
});
